module.exports = __webpack_public_path__ + "static/media/event_popup01.04fc9ea8.svg";